// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"5006310fd716a713448d","263":"1767d5b6743cbae40ecf","791":"d1c2977d992ea2bd0471"}[chunkId] + ".js";
};